define('services/tableConfigSettingsService',[
    'lib/lodash4',
    'lib/bluebird',
	'services/userService',
	'services/userSettingsService'
], function(
    _,
    Promise,
	userService,
	userSettingsService
) {
    'use strict';

    var tableConfigSettingsService = {

        getSettings: function (tableId, defaultSettings) {

            tableId = "dataTables." + tableId;

            if(userService.currentUser()) {
                defaultSettings = defaultSettings || {};

                return userSettingsService.getSettings()
                    .then(function(settings) {
                        return _.assign(defaultSettings, settings[tableId]);
                    });
            }

            return Promise.reject(new Error("Cannot load user table settings without currentUser()."));
        },

        setSettings: function (tableId, settings) {

            tableId = "dataTables." + tableId;

            if(userService.currentUser()) {
                var newSettings = {};
                newSettings[tableId] = settings;
                return userSettingsService.setSettings(newSettings);
            }

            return Promise.reject(new Error("Cannot save user table settings without currentUser()."));
        },

        clearSettings: function (tableId) {

            tableId = "dataTables." + tableId;

            if(userService.currentUser()) {
                var newSettings = {};
                newSettings[tableId] = {};
                return userSettingsService.setSettings(newSettings);
            }

            return Promise.reject(new Error("Cannot clear user table settings without currentUser()."));
        }

    };

    return tableConfigSettingsService;

});

